import ApiService from "@/common/api.service";

const PATH = "stock/average-costs";

export const GET_STOCK_AVERAGE_COSTS = "getStockAverageCosts";
export const GET_STOCK_AVERAGE_COSTS_SUMMARY = "getStockAverageCostsSummary";
export const REVALUE_STOCK_AVERAGE_COST = "revalueStockAverageCost";

const actions = {
  [GET_STOCK_AVERAGE_COSTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data || response));
    });
  },

  [GET_STOCK_AVERAGE_COSTS_SUMMARY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/summary`, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data || response));
    });
  },

  [REVALUE_STOCK_AVERAGE_COST](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/revalue`, payload)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data || response));
    });
  },
};

export default {
  actions,
};
